import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  useBaseAsync,
  JuouProForm,
  JuouProFormItem,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'timer',
  setup(__props, { expose: __expose }) {

const currentDeviceId = ref<number>();
const visible = ref(false);

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();


const addInitValue = {

};
const conditionsInitValue = {
};


const modOptions = [
  {
    label: '打开',
    value: 'open',
  },
  {
    label: '关闭',
    value: 'close',
  },
];


const init = useBaseAsync(() => {
  columns.value = [
    {
      name: 'mod',
      label: '状态',
      type: 'select',
      options: modOptions,
      rule: [{ required: true }],
    },
    {
      name: 'base',
      label: '基准时间',
      type: 'datepick',
      pickType: 'datetime',
      rule: [{ required: true }],
      hideTable: true,
    },
    {
      name: 'createTime',
      label: '基准时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'interval',
      label: '间隔时间（s）',
      type: 'numberStr',
      rule: [{ required: true }],
      hideTable: true,
    },
    {
      name: 'ruleInterval',
      label: '间隔时间（s）',
      type: 'numberStr',
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'ruleCurrent',
      label: '已执行次数',
      type: 'numberStr',
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'ruleNextTime',
      label: '下次执行时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },
  ];
});


const operates: any[] = [];

const loading = ref(false);


const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  try {
    if (!currentDeviceId.value) {
      return {
        total: 0,
        data: [],
      };
    }
    loading.value = true;
    const res = await useApi().deviceApi.listTimerDeviceSetModDevice(currentDeviceId.value);
    const tableData: JuouProTableData = {
      total: res.data.data?.length || 0,
      data: res.data.data?.map((item: any) => ({
        ...item,
        mod: item.name.split('-')[3],
      })) || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => '您正在进行删除操作，请谨慎操作';


const addFun = useBaseAsync(async(data: any) => {
  if (!currentDeviceId.value) {
    return;
  }
  data.deviceId = currentDeviceId.value;
  await useApi().deviceApi.timerDeviceSetModDevice(data);
  ElMessage.success('添加成功');
});

/* const updateFun = useBaseAsync(async(data: any) => {
  await useApi().deviceApi.updateDeviceDevice(data);
  ElMessage.success('修改成功');
}); */
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().deviceApi.deleteTimerDeviceSetModDevice(data.name);
  ElMessage.success('删除成功');
});

init();

__expose({
  show: (deviceId: number) => {
    currentDeviceId.value = deviceId;
    tableRef.value?.refresh();
    visible.value = true;
  },
});


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "定时设置",
    draggable: "",
    width: "80vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(JuouProTable), {
        ref_key: "tableRef",
        ref: tableRef,
        columns: columns.value,
        "get-data": _unref(getData),
        "on-add": _unref(addFun),
        "on-delete": _unref(deleteFun),
        loading: loading.value,
        "is-dangder-delete": true,
        "format-dangder-delete-info": formatDeleteInfo,
        "row-key": "id",
        operates: operates,
        "add-init-values": addInitValue,
        "codition-init-values": conditionsInitValue
      }, null, 8, ["columns", "get-data", "on-add", "on-delete", "loading"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})